const collections = {
  role_type(value) {
    const map = {
      admin: "Администратор системы",
      content_manager: "Менеджер контента",
    };

    return map[value];
  },
  region(value) {
    const map = {
      ark: "Архангельск",
      vvo: "Владивосток",
      khv: "Хабаровск",
      kzn: "Казань",
      goj: "Нижний Новгород",
      svx: "Екатеринбург",
      pee: "Пермь",
      rov: "Ростов-на-Дону",
      tjm: "Тюмень",
      cek: "Челябинск",
      vog: "Волгоград",
      led: "Санкт-Петербург",
      gno: "Великий Новгород",
      slw: "Ставрополь",
      ptg: "Пятигорск",
      tul: "Тула",
      ren: "Оренбург",
      krr: "Краснодар",
      ovb: "Новосибирск",
      kja: "Красноярск",
      nbc: "Набережные Челны",
    };

    return map[value];
  },
  content_type(value) {
    const map = {
      music: "Музыка",
      cinema: "Кино",
      lecture: "Лекции",
      sport: "Спорт",
      event: "События",
    };

    return map[value];
  },
};

export function enumFilter(name, value) {
  if (typeof collections[name] === "function") {
    return collections[name](value) || value;
  }
  return value;
}
